<div *ngIf="prikaziStranicu" class="container-fluid">
  <h2 class="content-block">SIGNALNI LAGER SIROVINA</h2>
  <div class="content-block dnevniPlanWrapper">
    <div class="selectDates">
      <div class="dx-field">
        <div class="dx-fieldd">
          <dx-check-box
            [value]="sirovine"
            text="Sirovine"
            (onValueChanged)="odabranaGrupa1($event)"
            >
          </dx-check-box>
        </div>
        <div class="dx-fieldd">
          <dx-check-box
            [value]="ambalaza"
            text="Ambalaža"
            (onValueChanged)="odabranaGrupa2($event)"
            >
          </dx-check-box>
        </div>
        <div class="dx-fieldd">
          <dx-check-box
            [value]="potrosni"
            text="Potrošni"
            (onValueChanged)="odabranaGrupa3($event)"
            >
          </dx-check-box>
        </div>
        <div class="dx-fieldd">
          <dx-check-box
            [value]="svaStanja"
            text="Prikaži sva stanja"
            (onValueChanged)="prikaziSvaStanja($event)"
            >
          </dx-check-box>
        </div>
      </div>
    
      <div>
        <label>Odabir skladišta:</label>
        <dx-select-box
          #selectBoxSkladisteSirovina
          [disabled]="false"
          [items]="skladistaSirovina"
          [value]="skladistaSirovina[0].idposlovnica"
          valueExpr="idposlovnica"
          displayExpr="sifrainaziv"
          [width]="500"
          (onValueChanged)="promjenaSkladista($event)"
        >
        </dx-select-box>
      </div>
    </div>
    <div class="customTable dnevniPlan">
      <dx-data-grid
        [dataSource]="sveZalihe"
        noDataText="{{ poruka }}"
        [showColumnLines]="true"
        [wordWrapEnabled]="true"
        [showBorders]="false"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onCellPrepared)="onCellPrepared($event)"
        (onRowUpdated)="urediLager($event)"
      >
        <div *dxTemplate="let data of 'naslovTablice'" class="grid-wrapper">
          <div class="naslov">
            <h2 class="mb-0" style="padding-right: 30px">Pregled signalnog lagera sirovina</h2>
            <p class="mt-0"></p>
          </div>
        </div>

        <!-- <dxo-filter-row [visible]="true"></dxo-filter-row> -->
        <dxo-header-filter [visible]="true"></dxo-header-filter>

        <dxo-search-panel
          [visible]="true"
          [width]="210"
          placeholder="Pretraži..."
        >
        </dxo-search-panel>

        <dxo-paging [enabled]="true" [pageSize]="15"></dxo-paging>

        <dxo-pager
          [showPageSizeSelector]="true"
          [allowedPageSizes]="[20, 30, 40]"
          [showInfo]="true"
        >
        </dxo-pager>

        <dxo-editing
          mode="row"
          [allowAdding]="false"
          [allowUpdating]="true"
          [allowDeleting]="false"
        ></dxo-editing>

        <dxi-column
          dataField="ar_sifra"
          caption="Šifra"
          alignment="left"
          [allowEditing]="false"
          width="150"
        ></dxi-column>

        <dxi-column
          dataField="ar_naziv"
          caption="Naziv"
          alignment="left"
          [allowEditing]="false"
          width="fit-content"
        ></dxi-column>

        <dxi-column
          dataField="po_naziv"
          caption="Skladište"
          alignment="left"
          [allowEditing]="false"
          width="300"
        ></dxi-column>

        <dxi-column
          dataField="jedinicamjere_JM_SIFRA"
          caption="Jedinica mjere"
          alignment="center"
          [allowEditing]="false"
          width="150"
        ></dxi-column>

        <dxi-column
          dataField="za_stanje"
          caption="Stanje"
          width="150"
          [allowEditing]="false"
          alignment="right"
        ></dxi-column>

        <dxi-column
          dataField="za_maximum"
          caption="Maksimum"
          width="150"
          alignment="right"
        ></dxi-column>

        <dxi-column
          dataField="za_minimum"
          caption="Signalna zaliha"
          width="180"
          alignment="right"
        ></dxi-column>

      </dx-data-grid>
    </div>
  </div>
</div>
  